module.exports = require('./helpers/bundle-url').getBundleURL('imVHt') + "logo-dark.ba5147f0.svg";